module.exports = __webpack_public_path__ + "img/icon.chart.73da74ea.svg";